import { Stack, Typography } from "@mui/material";

import { useTheme } from "@mui/material/styles";
import { useTenantTranslation } from "hooks/formatters";

import { MaterialQuantityUnit } from "src/store/api/generatedApi";
import { formatMassDifference } from "../../utils";

interface CraneCellValueProps {
  filledMass: number;
  mass: number;
  unit?: MaterialQuantityUnit;
}

export const CraneCellValue = ({
  filledMass,
  mass,
  unit,
}: CraneCellValueProps) => {
  const theme = useTheme();
  const { t } = useTenantTranslation();

  const color = theme.palette.primary.main;

  const { current, target } = formatMassDifference(mass, filledMass);

  // Show plus sign for additions when mix_quantity is "grabs"
  const shouldShowPlus = unit === "grab";
  const displayCurrent =
    shouldShowPlus && filledMass > 0 ? `+${current}` : current;
  const displayTarget = shouldShowPlus && mass > 0 ? `+${target}` : target;

  return (
    <Stack
      direction="column"
      alignItems="center"
      sx={{ minWidth: { xs: 70, md: 90, lg: 100 } }}
    >
      <Typography
        className="material-adjusted-mass"
        sx={{
          fontSize: { xs: 32, md: 40, lg: 48 },
          color,
          fontWeight: "bold",
          lineHeight: 1.1,
        }}
      >
        {displayCurrent}
      </Typography>
      <Typography
        className="material-target-mass"
        variant="caption"
        sx={{
          fontSize: { xs: "0.7rem", md: "0.75rem", lg: "0.875rem" },
        }}
      >
        {t("target")}: {displayTarget}
      </Typography>
    </Stack>
  );
};
